import * as PropTypes from "prop-types"
import { I18n } from "react-polyglot-hooks"
import { parseMDX } from "lib/mdx"
import LegalScene from "scenes/LegalScene"
import common from "../../i18n/pt/common"
import markdown from "../../i18n/pt/legal/terms.md"

export default function TermosCondicoes({ content }) {
  return (
    <I18n locale="pt" phrases={{ ...common }}>
      <LegalScene page="terms" markdown={content} />
    </I18n>
  )
}

TermosCondicoes.propTypes = {
  content: PropTypes.string.isRequired
}

export async function getStaticProps() {
  const parsedMdx = await parseMDX(markdown)
  return { props: { content: parsedMdx } }
}
